export default "__VITE_PUBLIC_ASSET__ee011120__"